import { MapPinOff, Navigation } from "lucide-react";
import { get } from "@/lib/api";
import { useAsync } from "@/lib/queries";
import { STATUS_HEX } from "@/lib/mapColors";
import { StatusBadge } from "@/components/StatusBadge";
import { TeamMap } from "./TeamMap";

const mapsUrl = (a) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${a.full_address} ${a.postcode}`)}`;

const Popup = ({ a, n }) => (
  <div className="min-w-[180px] space-y-1.5" data-testid={`run-map-popup-${a.id}`}>
    <p className="font-data text-[10px] uppercase tracking-[0.14em] text-blue-700">Address {n}</p>
    <p className="text-sm font-semibold leading-snug text-slate-900">{a.full_address}</p>
    <p className="font-data text-xs font-bold text-blue-800">{a.postcode}</p>
    <StatusBadge status={a.status} />
    <a href={mapsUrl(a)} target="_blank" rel="noreferrer" className="flex items-center gap-1 pt-1 text-sm font-semibold !text-blue-700 hover:underline">
      <Navigation className="h-3.5 w-3.5" /> Open in Maps
    </a>
  </div>
);

export const RunMiniMap = ({ runId, refreshKey }) => {
  const { data } = useAsync(() => get(`/runs/${runId}/map`), [runId, refreshKey]);
  const all = (data || []).map((a, i) => ({ a, n: i + 1 }));
  const placed = all.filter(({ a }) => a.lat != null);
  const unplaced = all.filter(({ a }) => a.lat == null);
  const points = placed.map(({ a, n }) => ({
    key: a.id, lat: a.lat, lng: a.lng, area: a.area, boundary: a.boundary, color: STATUS_HEX[a.status], pulse: a.status === "in_progress", label: String(n),
    popup: <Popup a={a} n={n} />,
  }));
  if (data && !data.length) return null;
  return (
    <div className="space-y-2" data-testid="run-mini-map">
      <TeamMap points={points} fitKey={placed.map(({ a }) => a.id).join("|")} className="h-[260px] sm:h-[300px]" testId="run-map" />
      {unplaced.length > 0 && (
        <p className="flex items-start gap-1.5 text-xs text-amber-800" data-testid="run-map-unplaced">
          <MapPinOff className="mt-0.5 h-3.5 w-3.5 shrink-0" />
          Couldn&apos;t place on map: {unplaced.map(({ a, n }) => `${n}. ${a.full_address} (${a.postcode})`).join(", ")}
        </p>
      )}
    </div>
  );
};
